<template lang="pug">
  v-dialog(
    v-model="dialog"
    class="full-width w-dialog" width=500
    :disabled="hasErrors || disabled"
    persistent
  )

    // Button Activator Slot
    slot(
      slot="activator"
      @click="$emit('input', dialog)"
    )
      v-btn(slot="activator" :color="color"
        :class="textStyle"
        @click="$emit('input', dialog)"
        id="gtm.easyLink"
        :disabled="disabled"
      )
        //v-icon(class="mr-2" color="blue") send
        img(class="mr-2" :src="icon")
        | Send Easy Link

    // Modal Card
    v-card
      div.text-xs-right
        v-btn.gtm_close(
          icon
          @click="closeDialog"
        )
          v-icon mdi-close
      v-card-text
        fan-loader(
          :loading="sending"
          class="mt-0"
        )
          Send(
            v-if="flowState === 'UNSENT'"
            @send="sendEasyLink"
            @input="x => focusFieldValue = x"
          )

          Resend(
            v-else-if="flowState === 'EXISTS'"
            :sentTo="focusFieldValue"
            @resend="resendEasyLink"
          )

          div(v-else-if="flowState === 'SUCCESS'")
            //div(class="headline") {{successMsg}}
            Success(
              :src="successPlane"
              :responseMsg="successMsg"
              :sentTo="focusFieldValue"
            )

          div.mb-5.w.title(v-else-if="flowState === 'ERROR'")
            | {{ errMsg }}

          div(slot="loadingMsg"
            class="full-width text-xs-center headline my-2"
          ) Sending Easy Link...

</template>

<script>
  import Resend from './EasyLinkDialog/Resend'
  import Send from './EasyLinkDialog/Send'
  import FanLoader from '@/components/FanLoader'
  import Success from './EasyLinkDialog/Success'
  import ValidationRules from '@/mixins/ValidationRules'

  export default {
    name: 'easy-link-dialog',
    //TODO how to verify send and resend are handled?
    props: {
      hasErrors: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      fromPreQualResults: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Resend,
      Send,
      FanLoader,
      Success,
    },
    data() {
      return {
        dialog: false,
        errMsg: '',
        existingEasyLink: '',
        focusFieldValue: '',
        icon: require('@/assets/success-plane.svg'),
        sending: false,
        successMsg: '',
        successPlane: require('@/assets/success-plane.svg'),
      }
    },
    computed: {
      flowState() {
        return (!this.successMsg && !this.errMsg)
          ? 'UNSENT'
             : (this.successMsg && !this.errMsg)
          ? 'SUCCESS'
             : (!this.successMsg && this.errMsg)
          ? (this.existingEasyLink)
             ? 'EXISTS'
             : 'ERROR'
          : 'UNSENT'
      },
      color() {
        return this.fromPreQualResults ? "blue" : "white"
      },
      textStyle() {
        return this.fromPreQualResults ? "send-btn full-width mx-0 white--text" : "send-btn full-width mx-0 blue--text"
      }
    },
    watch: {
      dialog() {
        const vm = this
        setTimeout(() => {
          vm.reset()
        }, 1000)
      },
    },
    methods: {
      closeDialog() {
        this.dialog=false
      },

      reset() {
        this.sending = false
        this.errMsg = ''
        this.successMsg = ''
        this.existingEasyLink = ''
      },

      resendEasyLink() {
        this.errMsg = ''
        this.sending = true

        const { existingEasyLink: guid } = this
        this.$emit('resend', { guid },
          res => {
            this.sending = false
            this.successMsg = 'Easy Link Resent'
          },
          err => {
            this.sending = false
            this.errMsg = 'Not sure why, but we couldn\'t resend your easy link. Contact us for more help.'
          }
        )
      },

      sendEasyLink(payload) {
        this.sending = true
        this.$emit('send', payload,
          res => {
            
            this.sending = false
            if (res.data) {
              if (res.data.err) {
                if (res.data.err.code === 'UsernameExistsException') {
                  this.errMsg = 'Easy link already exists.'
                  this.existingEasyLink = res.data.guid
                } else {
                  this.errMsg = 'Server error:' + res.data.err.message
                }
              } else if (res.data.message) {
                this.successMsg = res.data.message
              } else {
                this.successMsg = 'Done!'
              }
            } else {
              this.errMsg = 'Not sure why, but we couldn\'t send your easy link. Contact us for more help.'
            }
          },
          err => {
            this.sending = false
            this.errMsg = 'Not sure why, but we couldn\'t send your easy link. Contact us for more help.'
          }
        )
      },
    },
  }
</script>

<style>
  .w.subtitle-1 {
    font-size: 22px!important;
    line-height: 35px;
    font-weight: 300;
  }
</style>

<style scoped lang="scss">
  .w-dialog {
    text-align: center;
    font-family: Roboto,sans-serif!important;
  }

  .greyed-out >>> input {
    color: rgba(0,0,0,.38)!important;
  }

  .full-width {
    width: 100%;
  }

  .send-btn {
    & img {
      max-height: 30px;
    }
  }

  .w.title {
    font-weight: inherit;
  }
</style>

